import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Clearfix, Grid, Row, Col, Button, Alert, Label } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import Slider from 'rc-slider';
import { isMobile, BrowserView, MobileView } from 'react-device-detect';
import Camera from 'react-html5-camera-photo';
import SignaturePad from 'react-signature-pad-wrapper';
import Modal from 'components/Modal';
import {
  forEach as _forEach,
  findIndex as _findIndex,
  some as _some,
  concat as _concat,
  filter as _filter,
  find as _find,
  indexOf as _indexOf,
  remove as _remove,
  uniqBy as _uniqBy,
} from 'lodash';

import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { changeUploadContext, resetUploadContext, fileUploadHelper } from 'actions/UploadActions';
import { resetCheckout, initCheckout, updateCheckout } from 'actions/CheckoutActions';
import { getNameInCurrentLanguage } from 'helpers/intl';
import { dataURItoBlob } from 'helpers/http';
import { getAllowedCarRentalMileage, getCarRentalMileageSurcharge } from 'helpers/items';
import { getMainDomain } from 'helpers/whiteLabel';
import { userDataForCheckout } from 'helpers/clients';

import List from 'components/List';
import Data from 'components/Data';

import Loader from 'components/layout/Loader';
import AdditionalCostsPositions from 'components/layout/lead/changeStageChecker/AdditionalCostsPositions';
import DocUpload from 'components/layout/lead/changeStageChecker/DocUpload';
import DocPhoto from 'components/layout/lead/changeStageChecker/DocPhoto';

import FormErrors from 'components/forms/FormErrors';
import FormInput from 'components/forms/FormInput';
import FormTextarea from 'components/forms/FormTextarea';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormCheckbox from 'components/forms/FormCheckbox';
import FormSwitchery from 'components/forms/FormSwitchery';

import PaymentOptions from 'components/ePayment/PaymentOptions';
import CheckoutProceedButton from 'components/ePayment/CheckoutProceedButton';

import { PAYMENT_CASH, PAYMENT_NONE } from 'js/constants';

const initialState = {
  checked: false,
  show: false,
  initClose: false,
  mileageLoaded: false,
  tankVolumeLoaded: false,

  docUpload: false,
  docUploadType: null,
  docUploadTarget: null,
  makeDocPhoto: false,

  handover: false, // should we display the handover form?
  handoverDifficulties: null,
  selectedHandoverAttributes: [],
  handoverFuelLevel: 100,
  handoverPreviousMileage: 0,
  handoverMileage: 0,
  handoverTankVolume: 0,

  damages: false, // show damage view? the user may choose a side
  damageSide: null, // which side has the user selected to view/add new damages
  damagedSides: {
    front: [],
    back: [],
    left: [],
    right: [],
    top: [],
    interior: [],
  }, // list of damages for each side
  damagedSidesPhotos: [], // list of photos with side as attribute
  makeDamagePhoto: false, // should we show the camera?
  damagePhotoTaken: false, // was a photo just taken?
  showSignaturePad: false, // show the pad for the cutomer to sign?
  signaturePresent: false, // is there anything written doen on the signature pad?
  signatureData: null,

  checkedClientDocs: [], // which clien document types were reviewed?
  checkedLeadDocs: [], // which lead document types were reviewed?

  targetId: null,
  budget: null,
  car: null,
  item: null,
  orderId: null,
  requireClientDocuments: [],
  requireLeadDocuments: [],
  isHandoverRequired: false,
  isClientRequired: false,
  isBudgetRequired: false,
  isCarRequired: false,
  isItemRequired: false,
  isOrderRequired: false,

  chargeAdditionalCosts: true,
  newPaymentMethod: true,
  errors: [],
};

const damagesConfig = [
  { pos: 'front', top: 10, left: 50 },
  { pos: 'left', top: 48, left: 10 },
  { pos: 'right', top: 48, left: 90 },
  { pos: 'back', top: 88, left: 50 },
  { pos: 'top', top: 60, left: 50 },
  { pos: 'interior', top: 30, left: 50 },
];

class LeadChangeStageChecker extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...initialState };
  }

  getTarget = () => {
    const { lead } = this.props;
    return lead.target;
  };

  getCar = () => {
    const { lead } = this.props;
    return lead.items;
  };

  updateTarget = (name, value) => {
    const { doUpdateCheckout } = this.props;

    this.setState({ targetId: value.username }, () => {
      doUpdateCheckout({ userData: userDataForCheckout(value) });
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const {
      intl: { messages },
      show: propsShow,
      lead,
      newStageId,
      formStatus,
      handoverAttributes,
      carMileage,
      carTankVolume,
      countUploading,
      uploadFile,
      doNotify,
      onSubmit,
    } = this.props;
    const { show, checked } = this.state;

    if (!prevState.checked && checked && !show) {
      // we checked all requirements and everything was OK
      // we can change the stage and close the stage checker
      onSubmit(lead.id, { newStage: newStageId, payment: { plugin: PAYMENT_NONE, type: 'none' } });
    }

    // check if we need to andvance directly to handover
    if (!prevState.checked && checked && show) {
      const { targetId, car, requireClientDocuments, requireLeadDocuments, isHandoverRequired } = this.state;
      if (targetId && car && !requireClientDocuments.length && !requireLeadDocuments.length && isHandoverRequired) {
        this.setState({ handover: true });
      }
    }

    if (prevProps.handoverAttributes.pending && !handoverAttributes.pending && !handoverAttributes.hasError) {
      const selectedHandoverAttributes = [];
      _forEach(handoverAttributes.data.list, attr => {
        selectedHandoverAttributes.push(attr.id);
      });

      this.setState({ selectedHandoverAttributes });
    }

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      const handover = formStatus.response && formStatus.response.handover ? formStatus.response.handover : null;
      let uploadCounter = 0;

      if (handover) {
        if (handover.damages && prevState.damagedSidesPhotos.length) {
          for (let i = 0; i < prevState.damagedSidesPhotos.length; i++) {
            const damagePhoto = prevState.damagedSidesPhotos[i];

            // we need a damage id for the URL
            let damageId = 'new';
            for (let j = 0; j < handover.damages.length; j++) {
              if (handover.damages[j].side === damagePhoto.side) {
                damageId = handover.damages[j].id;
                break; // break when we have the damage id
              }
            }

            // this is the configuration for the upload
            const file = damagePhoto.file ? damagePhoto.file : dataURItoBlob(damagePhoto.dataURI);
            const uploadLink = `/api/handovers/${handover.id}/damages/${damageId}/photos.json`;
            const args = { side: damagePhoto.side };

            uploadFile(file, uploadLink, args);
            uploadCounter++;
          }
        }

        // check if we have the signature data
        if (prevState.signatureData) {
          const file = dataURItoBlob(prevState.signatureData);
          const uploadLink = `/api/handovers/${handover.id}/signatures.json`;

          uploadFile(file, uploadLink);
          uploadCounter++;
        }
      }

      if (uploadCounter === 0) {
        this.doClose();
      }
    }

    if (prevProps.carMileage.pending && !carMileage.pending && !carMileage.hasError) {
      if (!prevState.handoverMileage) {
        this.setState({
          mileageLoaded: true,
          handoverPreviousMileage: carMileage.data,
          handoverMileage: carMileage.data,
        });
      }
    }

    if (prevProps.carTankVolume.pending && !carTankVolume.pending && !carTankVolume.hasError) {
      if (!prevState.handoverTankVolume) {
        this.setState({ tankVolumeLoaded: true, handoverTankVolume: carTankVolume.data });
      }
    }

    if (prevProps.countUploading > 0 && countUploading === 0) {
      // files finished uploading
      doNotify(1, messages.image_upload_finished);
      this.doClose();
    }

    // lead was dropped. check what we need to do
    if (propsShow && !prevProps.show) {
      this.setState(this.check(), this.onCheckFinished);
    }
  };

  // if the check is finished and we should show the popup,
  // update the upload context and init the checkout
  onCheckFinished = () => {
    const { lead, updateUploadContext, doInitCheckout } = this.props;
    const { show } = this.state;

    if (show) {
      // the modal is now open
      // update the upload context
      updateUploadContext({
        type: 'leadHandover',
        leadId: lead.id,
        uploadLink: '',
      });

      doInitCheckout([], userDataForCheckout(this.getTarget()), {
        activePaymentPlugin: PAYMENT_CASH,
        payment: 'cash',
        navToCheckout: false,
      });
    }
  };

  raiseError = text => {
    clearTimeout(this.buttonErrorTimeout);

    this.setState({ errors: [text] });
    this.buttonErrorTimeout = setTimeout(() => {
      this.setState({ errors: [] });
    }, 15000);
  };

  // check if the modal should be shown
  check = () => {
    const { lead, newStageId } = this.props;
    const { checked } = this.state;

    if (lead && !checked) {
      const { pipeline } = lead;

      const oldStageIndex = _findIndex(pipeline.stages, ['id', lead.current_stage || lead.currentStage]);
      const newStageIndex = _findIndex(pipeline.stages, ['id', newStageId]);

      const indexesToCheck = [];

      if (newStageIndex > oldStageIndex) {
        for (let i = oldStageIndex + 1; i <= newStageIndex; i++) {
          indexesToCheck.push(i);
        }
        if (oldStageIndex === 0) {
          indexesToCheck.splice(0, 0, 0);
        }
      } else {
        indexesToCheck.push(newStageIndex);
      }

      // check if any documents are required
      let show = false;
      let targetId = null;
      let car = null;
      const item = null;
      const budget = null;
      const orderId = null;
      let requireClientDocuments = [];
      let requireLeadDocuments = [];
      let isClientRequired = false;
      let isCarRequired = false;
      let isItemRequired = false;
      let isBudgetRequired = false;
      let isOrderRequired = false;
      let isHandoverRequired = false;
      for (let i = indexesToCheck[0]; i < indexesToCheck.length + indexesToCheck[0]; i++) {
        const stage = pipeline.stages[i];
        if (stage?.is_client_required || stage?.isClientRequired) {
          // check if client is assigned
          if (!lead.target || !lead.target.username) {
            isClientRequired = true;
            show = true;
          }
        }
        const target = this.getTarget();
        targetId = target ? target.username : null;

        // this stage requires an item. Check if the lead contains one. If not, user must select something
        if (stage?.is_item_required || stage?.isItemRequired) {
          // if an item is required, check if any items are assigned to the lead
          isItemRequired = !lead.items.length;

          // or, when the lead has an order, if the order contains an item
          if (isItemRequired && lead.orders) {
            isItemRequired = !_some(lead.orders, order => !order.items.length);
          }

          if (isItemRequired) {
            show = true;
          }
        }

        if (stage?.is_budget_required || stage?.isBudgetRequired) {
          if (!lead.budget) {
            isBudgetRequired = true;
            show = true;
          }
        }

        if (stage?.is_order_required || stage?.isOrderRequired) {
          if (!lead.order) {
            isOrderRequired = true;
            show = true;
          }
        }

        // this stage requires a handover. Each handover requires a car.
        if (stage?.is_handover_required || stage?.isHandoverRequired) {
          isHandoverRequired = true;
          // check if a car is assigned to the lead
          isCarRequired = !_some(lead.items, { type: 'car' });
          if (!isCarRequired) {
            car = _find(lead.items, { type: 'car' });
          }

          // or, when the lead has an order, if the order contains a car
          if (isCarRequired && lead.orders) {
            isCarRequired = !_some(lead.orders, order => _some(order.items, { type: 'car' }));
          }
          if (!isCarRequired) {
            // car = _find(lead.orders, order => _fin{ type: 'car' });
          }

          show = true;
        }

        if (stage?.require_client_documents && stage?.require_client_documents.length) {
          show = true;
          requireClientDocuments = _concat(
            requireClientDocuments,
            stage.require_client_documents.map(clientDoc => clientDoc.doc_type)
          );
        } else if (stage?.requireClientDocuments && stage?.requireClientDocuments.length) {
          show = true;
          requireClientDocuments = _concat(
            requireClientDocuments,
            stage.requireClientDocuments.map(clientDoc => clientDoc.docType)
          );
        }

        if (stage?.require_lead_documents && stage?.require_lead_documents.length) {
          show = true;
          requireLeadDocuments = _concat(
            requireLeadDocuments,
            stage.require_lead_documents.map(leadDoc => leadDoc.doc_type)
          );
        } else if (stage?.requireLeadDocuments && stage?.requireLeadDocuments.length) {
          show = true;
          requireLeadDocuments = _concat(
            requireLeadDocuments,
            stage.requireLeadDocuments.map(leadDoc => leadDoc.docType)
          );
        }
      }

      requireClientDocuments = _uniqBy(requireClientDocuments, 'id') || [];
      requireLeadDocuments = _uniqBy(requireLeadDocuments, 'id') || [];

      return {
        initClose: false,
        checked: true,
        show,
        targetId,
        car,
        item,
        orderId,
        budget,
        requireClientDocuments,
        requireLeadDocuments,
        isClientRequired,
        isCarRequired,
        isItemRequired,
        isBudgetRequired,
        isOrderRequired,
        isHandoverRequired,
        damagedSides: { front: [], back: [], left: [], right: [], top: [], interior: [] },
        damagedSidesPhotos: [],
        makeDamagePhoto: false,
        damagePhotoTaken: false,
        showSignaturePad: false,
        signaturePresent: false,
        chargeAdditionalCosts: true,
        docUpload: false,
        docUploadType: null,
        docUploadTarget: null,
      };
    }

    return { show: false };
  };

  close = () => {
    const { isHandoverRequired } = this.state;

    if (isHandoverRequired) {
      this.setState(prevState => ({ initClose: !prevState.initClose }));
    } else {
      this.doClose();
    }
  };

  doClose = () => {
    const { doResetUploadContext, close } = this.props;

    this.setState({
      ...initialState,
      selectedHandoverAttributes: [],
      checkedClientDocs: [],
      checkedLeadDocs: [],
      damagedSidesPhotos: [],
    });

    doResetUploadContext();
    close();
  };

  getSubmitData = () => {
    // check if we there are any additional costs
    const { additionalCostsPositions, additionalCostsTotal } = this.getAdditionalCosts();

    const { lead, newStageId, handoverAttributes } = this.props;
    const {
      targetId,
      car,
      item,
      orderId,
      budget,
      checkedClientDocs,
      checkedLeadDocs,
      isHandoverRequired,
      isItemRequired,
      isBudgetRequired,
      isOrderRequired,
      handoverDifficulties,
      selectedHandoverAttributes,
      handoverFuelLevel,
      handoverPreviousMileage,
      handoverMileage,
      handoverTankVolume,
      chargeAdditionalCosts,
      showSignaturePad,
    } = this.state;

    // the signature pad data needs to be transformed to data URL before it may be uploaded to the backend
    if (showSignaturePad && this.signaturePad) {
      this.setState({ signatureData: this.signaturePad.toDataURL() });
    }

    // base data that will be submitted
    let data = {
      newStage: newStageId,
      checkedClientDocs,
      checkedLeadDocs,
      lead: {
        target: { username: targetId },
      },
    };

    // add item data if an item is required
    if (isItemRequired) {
      data = {
        ...data,
        lead: {
          ...data.lead,
          items: _concat(lead.items || [], [{ id: item.id }]),
        },
      };
    }

    // if budget is required, add it to the lead
    if (isBudgetRequired) {
      data = { ...data, lead: { ...data.lead, budget } };
    }

    // if order is required, add the order data to the lead
    if (isOrderRequired) {
      data = { ...data, lead: { ...data.lead, order: { id: orderId } } };
    }

    // add handover infos to the form data
    if (isHandoverRequired) {
      // format the damages array so that it will automaticaly be saved in the backend
      const damages = [];
      _forEach(this.state.damagedSides, (sideDamages, side) => {
        _forEach(sideDamages, sideDamage => {
          damages.push({
            side,
            ...sideDamage,
          });
        });
      });

      data = {
        ...data,
        carId: car.id,
        handover: {
          item: { id: car.id },
          difficulties: handoverDifficulties,
          previousMileage: handoverPreviousMileage,
          mileage: handoverMileage,
          tankVolume: handoverTankVolume,
          fuelLevel: handoverFuelLevel,
          attributes: selectedHandoverAttributes.map(attr => {
            return _find(handoverAttributes.data.list, ['id', attr]);
          }),
          damages,
        },
      };

      // add information about additional costs
      if (additionalCostsTotal > 0 && chargeAdditionalCosts) {
        data.additionalCosts = {
          charge: chargeAdditionalCosts,
          positions: additionalCostsPositions,
        };
      }
    }

    return data;
  };

  formValidate = () => {
    return new Promise((resolve, reject) => {
      if (this.getMaySubmit()) {
        resolve(this.getSubmitData());
      } else {
        reject();
      }
    });
  };

  doSubmit = data => {
    const { lead, onSubmit } = this.props;
    onSubmit(lead.id, data);
  };

  formSubmit = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (this.getMaySubmit()) {
      this.doSubmit({
        ...this.getSubmitData(),
        payment: {
          plugin: PAYMENT_NONE,
          type: 'none',
        },
      });
    }
  };

  showSignaturePad = () => {
    this.setState({ showSignaturePad: true });
  };

  getClientDocChecked = docId => {
    const { checkedClientDocs } = this.state;
    return _indexOf(checkedClientDocs, docId) > -1;
  };

  getLeadDocChecked = docId => {
    const { checkedLeadDocs } = this.state;
    return _indexOf(checkedLeadDocs, docId) > -1;
  };

  clientDocChanged = (docId, checked, callback = null) => {
    const { checkedClientDocs } = this.state;

    let docs = checkedClientDocs.slice();
    if (!docs) {
      docs = [];
    }

    if (checked) {
      docs.push(docId);
    } else {
      docs = _remove(docs, d => {
        return d !== docId;
      });
    }

    this.setState({ checkedClientDocs: docs }, callback);
  };

  leadDocChanged = (docId, checked, callback = null) => {
    const { checkedLeadDocs } = this.state;

    let docs = checkedLeadDocs.slice();
    if (!docs) {
      docs = [];
    }

    if (checked) {
      docs.push(docId);
    } else {
      docs = _remove(docs, d => {
        return d !== docId;
      });
    }

    this.setState({ checkedLeadDocs: docs }, callback);
  };

  showDocUpload = (e, docUploadType, docUploadTarget) => {
    e.preventDefault();
    this.setState({ docUpload: true, docUploadType, docUploadTarget });
  };

  closeDocUpload = e => {
    e.preventDefault();
    this.setState({ docUpload: false });
  };

  makeDocPhoto = e => {
    e.preventDefault();
    this.setState({ makeDocPhoto: true });
  };

  closeMakeDocPhoto = e => {
    e.preventDefault();
    this.setState({ makeDocPhoto: false });
  };

  // execute when a document gets uploaded
  docUploaded = (/* doc */) => {
    const {
      intl: { messages },
      doNotify,
    } = this.props;
    const { docUploadTarget, docUploadType } = this.state;

    const callback = () => {
      this.setState({
        docUpload: false,
        makeDocPhoto: false,
        docUploadType: null,
        docUploadTarget: null,
      });
    };

    if (docUploadTarget === 'client') {
      this.clientDocChanged(docUploadType.id, true, callback);
    } else {
      this.leadDocChanged(docUploadType.id, true, callback);
    }

    doNotify(1, messages.document_saved);
  };

  getClientDocInput = (docType, key) => {
    const {
      intl: { messages },
      appIntl,
      clientDocs,
    } = this.props;
    const { isClientRequired, targetId } = this.state;

    const docTypeName = docType ? getNameInCurrentLanguage(docType.name, appIntl) : null;

    if ((isClientRequired && !targetId) || !docType) {
      return null;
    }

    if (clientDocs.pending) {
      return (
        <div className="form-group form-group-default" key={key}>
          <label>{docTypeName}</label>
          <div>
            <i className="fa fa-fw fa-circle-notch fa-spin m-r-10" />
          </div>
        </div>
      );
    }

    if (
      _findIndex(clientDocs.data.list, doc => {
        return !!doc.type && doc.type.id === docType.id;
      }) > -1
    ) {
      return (
        <FormCheckbox
          key={key}
          label={docTypeName}
          options={[{ label: messages.document_reviewed, value: docType.id }]}
          name={docType.id}
          onChange={(name, values) => {
            this.clientDocChanged(name, !!values.length && values[0] === docType.id);
          }}
          values={this.getClientDocChecked(docType.id) ? [docType.id] : null}
        />
      );
    }

    return (
      <div className="form-group form-group-default" key={key}>
        <label>{docTypeName}</label>
        <div>
          <Alert bsStyle="warning" className="no-margin">
            <p className="col-xs-6 no-padding">{messages.document_is_missing}</p>
            <p className="text-right no-margin bold">
              <a href="#showDocUpload" className="text-warning" onClick={e => this.showDocUpload(e, docType, 'client')}>
                <i className="fal fa-upload" />{' '}
                <FormattedMessage id="upload_document_name_now" values={{ name: docTypeName }} />
              </a>
            </p>
          </Alert>
        </div>
      </div>
    );
  };

  getLeadDocInput = (docType, key) => {
    const {
      intl: { messages },
      appIntl,
      leadDocs,
    } = this.props;

    const docTypeName = docType ? getNameInCurrentLanguage(docType.name, appIntl) : null;

    if (!docType) {
      return null;
    }

    if (leadDocs.pending) {
      return (
        <div className="form-group form-group-default" key={key}>
          <label>{docTypeName}</label>
          <div>
            <i className="fa fa-fw fa-circle-notch fa-spin m-r-10" />
          </div>
        </div>
      );
    }

    if (
      _findIndex(leadDocs.data.list, doc => {
        return doc.type.id === docType.id;
      }) > -1
    ) {
      return (
        <FormCheckbox
          key={key}
          label={docTypeName}
          options={[{ label: messages.document_reviewed, value: docType.id }]}
          name={docType.id}
          onChange={(name, values) => {
            this.leadDocChanged(name, !!values.length && values[0] === docType.id);
          }}
          values={this.getLeadDocChecked(docType.id) ? [docType.id] : null}
        />
      );
    }

    return (
      <div className="form-group form-group-default" key={key}>
        <label>{docTypeName}</label>
        <div>
          <Alert bsStyle="warning" className="no-margin">
            <p className="col-xs-6 no-padding">{messages.document_is_missing}</p>
            <p className="text-right no-margin bold">
              <a href="#showDocUpload" className="text-warning" onClick={e => this.showDocUpload(e, docType, 'lead')}>
                <i className="fal fa-upload" />{' '}
                <FormattedMessage id="upload_document_name_now" values={{ name: docTypeName }} />
              </a>
            </p>
          </Alert>
        </div>
      </div>
    );
  };

  // check if user may submit the form
  getMaySubmit = () => {
    const { clientDocs, leadDocs } = this.props;
    const {
      targetId,
      car,
      item,
      orderId,
      budget,
      requireClientDocuments,
      checkedClientDocs,
      requireLeadDocuments,
      checkedLeadDocs,
      isClientRequired,
      isCarRequired,
      isItemRequired,
      isBudgetRequired,
      isOrderRequired,
    } = this.state;

    if (isClientRequired && !targetId) {
      return false;
    }
    if (requireClientDocuments.length && clientDocs.pending) {
      return false;
    }
    if (requireLeadDocuments.length && leadDocs.pending) {
      return false;
    }
    if (!checkedLeadDocs && requireLeadDocuments.length) {
      return false;
    }
    if (checkedLeadDocs && requireLeadDocuments.length && checkedLeadDocs.length !== requireLeadDocuments.length) {
      return false;
    }
    if (!checkedClientDocs && requireClientDocuments.length) {
      return false;
    }
    if (
      checkedClientDocs &&
      requireClientDocuments.length &&
      checkedClientDocs.length !== requireClientDocuments.length
    ) {
      return false;
    }
    if (isCarRequired && !car) {
      return false;
    }
    if (isOrderRequired && !orderId) {
      return false;
    }
    if (isItemRequired && !item) {
      return false;
    }
    if (isBudgetRequired && (!budget || budget < 0)) {
      return false;
    }

    return true;
  };

  // open damage details
  openDamageDetails = side => {
    this.setState({ damageSide: side }, () => {
      const { damagedSides } = this.state;
      if (damagedSides[side].length === 0) {
        this.addDamage();
      }
    });
  };

  // close damage details
  closeDamageDetails = e => {
    e.preventDefault();
    this.setState({ damageSide: null });
  };

  // add a damage note to a specific side of the car
  addDamage = () => {
    const { damageSide, damagedSides: currentDamagedSides } = this.state;
    const newDamage = { notes: '' };

    const damagedSides = {
      front: currentDamagedSides.front.slice(),
      back: currentDamagedSides.back.slice(),
      left: currentDamagedSides.left.slice(),
      right: currentDamagedSides.right.slice(),
      top: currentDamagedSides.top.slice(),
      interior: currentDamagedSides.interior.slice(),
    };

    damagedSides[damageSide].push(newDamage);

    this.setState({ damagedSides });
  };

  // set the damage notes text when user types
  updateDamageNotes = (notes, index) => {
    const { damageSide, damagedSides: currentDamagedSides } = this.state;
    const damage = { notes };

    const damagedSides = {
      front: currentDamagedSides.front.slice(),
      back: currentDamagedSides.back.slice(),
      left: currentDamagedSides.left.slice(),
      right: currentDamagedSides.right.slice(),
      top: currentDamagedSides.top.slice(),
      interior: currentDamagedSides.interior.slice(),
    };

    damagedSides[damageSide].splice(index, 1, damage);

    this.setState({ damagedSides });
  };

  // remove a damage note
  removeDamageNote = (index, side = null) => {
    const { damageSide: stateDamageSide, damagedSides: currentDamagedSides } = this.state;
    const damageSide = side === null ? stateDamageSide : side;

    const damagedSides = {
      front: currentDamagedSides.front.slice(),
      back: currentDamagedSides.back.slice(),
      left: currentDamagedSides.left.slice(),
      right: currentDamagedSides.right.slice(),
      top: currentDamagedSides.top.slice(),
      interior: currentDamagedSides.interior.slice(),
    };

    damagedSides[damageSide].splice(index, 1);

    this.setState({ damagedSides });
  };

  makeDamagePhoto = () => {
    this.setState({ makeDamagePhoto: true });
  };

  closeMakeDamagePhoto = e => {
    e.preventDefault();
    this.setState({ makeDamagePhoto: false });
  };

  addDamageImage = dataURI => {
    const { damageSide, damagedSidesPhotos: stateDamagedSidePhotos } = this.state;

    const damagedSidesPhotos = stateDamagedSidePhotos.slice();
    damagedSidesPhotos.push({
      side: damageSide,
      dataURI,
    });

    this.setState({ damagePhotoTaken: true, damagedSidesPhotos });
  };

  closeDamagePhotoTaken = e => {
    e.preventDefault();
    this.setState({ damagePhotoTaken: false });
  };

  removeDamageImage = index => {
    const { damagedSidesPhotos: stateDamagedSidePhotos } = this.state;

    const damagedSidesPhotos = stateDamagedSidePhotos.slice();
    damagedSidesPhotos.splice(index, 1);
    this.setState({ damagedSidesPhotos });
  };

  retryLastDamagePhoto = () => {
    const { damagedSidesPhotos: stateDamagedSidePhotos } = this.state;

    const damagedSidesPhotos = stateDamagedSidePhotos.slice();
    damagedSidesPhotos.splice(stateDamagedSidePhotos.length - 1, 1);
    this.setState({ damagedSidesPhotos, damagePhotoTaken: false });
  };

  closeSignaturePad = () => {
    this.setState({ showSignaturePad: false });
  };

  showDamageProtocol = e => {
    e.preventDefault();
    this.setState({ damages: true });
  };

  closeDamageProtocol = e => {
    e.preventDefault();
    this.setState({ damages: false });
  };

  getDamageInfos = () => {
    const { damagedSides, damagedSidesPhotos } = this.state;
    const damageInfos = {
      hasDamages: false,
    };

    for (let i = 0; i < damagesConfig.length; i++) {
      const damageConfig = damagesConfig[i];

      const hasNotes = !!(
        damagedSides[damageConfig.pos] &&
        damagedSides[damageConfig.pos].length &&
        damagedSides[damageConfig.pos][0].notes
      );
      const hasPhotos = _some(damagedSidesPhotos, ['side', damageConfig.pos]);

      damageInfos[damageConfig.pos] = {
        hasNotes,
        hasPhotos,
      };

      damageInfos.hasDamages = damageInfos.hasDamages || hasNotes || hasPhotos;
    }

    return damageInfos;
  };

  getAdditionalCosts = () => {
    const {
      intl: { messages },
      lead,
    } = this.props;
    const { show, handoverFuelLevel, handoverMileage, handoverPreviousMileage, handoverTankVolume } = this.state;

    let allowedRentalMileage = 0;
    let additionalCostsFuelLevel = false;
    let additionalCostsMileage = false;
    let additionalCostsDamage = false;
    const positions = [];
    let total = 0;

    if (show && lead) {
      const damageInfos = this.getDamageInfos();

      // check if the user needs to pay for fueling the car
      if (handoverFuelLevel < 100) {
        additionalCostsFuelLevel = true;
      }

      // check if the customer needs to pay for driving too many kilometers
      allowedRentalMileage = getAllowedCarRentalMileage(lead.orders);
      if (handoverMileage - handoverPreviousMileage > allowedRentalMileage) {
        additionalCostsMileage = true;
      }

      // check if there are any damages
      if (damageInfos.hasDamages) {
        additionalCostsDamage = true;
      }

      if (additionalCostsFuelLevel) {
        const quantity = Math.ceil((handoverTankVolume * (100 - handoverFuelLevel)) / 100);

        positions.push({
          group: 'FUELING_COSTS',
          name: messages.vehicle_fuel_costs,
          quantity,
          netPrice: 1.6 / 1.16, //I don't fix this
          grossPrice: 1.6,
          price: quantity * 1.6,
          quantityUnit: 'liter',
          quantityUnitName: messages.uom.liter,
          quantityUnitSymbole: messages.uom_symbole.liter,
        });

        total += quantity * 1.6;
      }

      if (additionalCostsMileage) {
        const { car } = this.state;
        const quantity = Math.round(handoverMileage - handoverPreviousMileage - allowedRentalMileage);
        const grossPrice = getCarRentalMileageSurcharge(car.pricing.weekday_price);

        positions.push({
          group: 'MILEAGE_SURCHARGE',
          name: messages.mileage_surcharge,
          quantity,
          netPrice: grossPrice / 1.16,
          grossPrice,
          price: quantity * grossPrice,
          quantityUnit: 'kilometer',
          quantityUnitName: messages.uom.kilometer,
          quantityUnitSymbole: messages.uom_symbole.kilometer,
        });

        total += quantity * grossPrice;
      }

      if (additionalCostsDamage) {
        const grossPrice = 1000;

        positions.push({
          group: 'INSURANCE_SELF_PARTICIPATION',
          name: messages.insurance_self_participation,
          quantity: 1,
          netPrice: grossPrice / 1.16,
          grossPrice,
          price: 1 * grossPrice,
          quantityUnit: 'piece',
          quantityUnitName: messages.uom.piece,
          quantityUnitSymbole: messages.uom_symbole.piece,
        });

        total += 1 * grossPrice;
      }
    }

    return {
      allowedRentalMileage,
      additionalCostsFuelLevel,
      additionalCostsMileage,
      additionalCostsDamage,
      additionalCostsPositions: positions,
      additionalCostsTotal: total,
    };
  };

  render() {
    const {
      intl: { messages },
      webApp,
      appIntl,
      projectConfig,
      lead,
      clientDocs,
      leadDocs,
      handoverAttributes,
      carMileage,
      carTankVolume,
      formStatus,
      uploadingFiles,
      countUploading,
    } = this.props;

    const { debug } = webApp;
    let modalClass = '';

    const {
      show,
      initClose,
      mileageLoaded,
      tankVolumeLoaded,
      targetId,
      car,
      item,
      orderId,
      budget,
      requireClientDocuments,
      requireLeadDocuments,
      isClientRequired,
      isCarRequired,
      isItemRequired,
      isBudgetRequired,
      isOrderRequired,
      isHandoverRequired,
      damagedSides,
      damagedSidesPhotos,
      makeDamagePhoto,
      damagePhotoTaken,
      showSignaturePad,
      signaturePresent,
      docUpload,
      docUploadTarget,
      makeDocPhoto,
      chargeAdditionalCosts,
      docUploadType,
      damageSide,
      errors,
    } = this.state;

    const projectDomain = getMainDomain(projectConfig.data, true, false);
    const damageInfos = this.getDamageInfos();
    const { additionalCostsPositions, additionalCostsTotal } = this.getAdditionalCosts();

    let renderResult = null;
    let renderTitle = null;
    if (show && lead) {
      // wait until all files finish uploading - show progress
      if (countUploading) {
        renderTitle = (
          <>
            {messages.uploading} <i className="fa fa-circle-notch fa-spin" />
          </>
        );
        renderResult = (
          <Clearfix>
            {!webApp.isOnline && (
              <Alert bsStyle="warning" className="m-b-20">
                <div className="bold">{messages.you_have_no_internet_connection}</div>
                <p>{messages.waiting_to_reconnect}</p>
              </Alert>
            )}

            {uploadingFiles.map((uploadingFile, i) => {
              let bgClass = 'bg-master';
              if (uploadingFile.isUploading) {
                bgClass = 'bg-complete';
              } else if (uploadingFile.isUploaded) {
                bgClass = 'bg-success';
              }

              return (
                <Col xs={12} sm={6} className="m-b-15" key={i}>
                  <div
                    className="relative"
                    style={{
                      paddingTop: '70%',
                      backgroundImage: 'url(' + uploadingFile.thumbnail + ')',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center center',
                    }}
                  >
                    <div
                      className={bgClass}
                      style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        opacity: 0.5,
                      }}
                    />
                    <div className="overlayer" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                      {uploadingFile.isUploading && <h2 className="text-white">{uploadingFile.progress}%</h2>}

                      {uploadingFile.isUploaded && (
                        <h2 className="text-white">
                          <i className="far fa-check" />
                        </h2>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Clearfix>
        );

        // user wants to close the handover
      } else if (initClose) {
        renderTitle = messages.handover;
        renderResult = (
          <>
            <h2 className="text-center">{messages.really_cancel}</h2>
            <p className="hint-text text-center">{messages.unsaved_information_will_be_lost}</p>
            <div className="text-center m-b-25">
              <Button
                bsStyle="primary"
                bsSize="lg"
                className="m-b-20"
                onClick={() => this.setState({ initClose: false })}
              >
                {messages.no}
              </Button>
            </div>

            <div className="text-center">
              <Button bsStyle="danger" onClick={this.doClose}>
                {messages.yes}
              </Button>
            </div>
          </>
        );

        // show a signature pad for the customer to sign the car return protocol
      } else if (showSignaturePad) {
        modalClass = 'full-width';

        renderTitle = messages.client_signature;
        renderResult = (
          <>
            <Grid fluid className="no-padding">
              <Row>
                <Col xs={12} md={7}>
                  <div className="b-a">
                    <SignaturePad
                      ref={ref => {
                        this.signaturePad = ref;
                      }}
                      options={{ onEnd: () => this.setState({ signaturePresent: true }) }}
                    />
                  </div>
                </Col>
                <Col xs={12} md={5}>
                  {additionalCostsTotal > 0 && chargeAdditionalCosts ? (
                    <>
                      <AdditionalCostsPositions
                        projectConfig={projectConfig}
                        additionalCostsPositions={additionalCostsPositions}
                        additionalCostsTotal={additionalCostsTotal}
                      />

                      <div className="m-t-20">
                        <PaymentOptions
                          clientId={targetId}
                          ePaymentTotal={additionalCostsTotal}
                          currency={webApp.currency}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <h4 className="text-success">
                        {messages.no_additional_costs}{' '}
                        <span className="hidden-md hidden-lg">
                          <i className="fal fa-thumbs-up" />
                        </span>
                      </h4>

                      <h1 className="text-success text-center xs-hidden sm-hidden m-t-60">
                        <i className="fal fa-thumbs-up fa-4x" />
                      </h1>
                    </>
                  )}
                </Col>
              </Row>
            </Grid>

            <div className="text-right m-t-15">
              <CheckoutProceedButton
                bsStyle={signaturePresent ? 'primary' : 'default'}
                bsSize="lg"
                iconClassName="fal fa-save"
                disabled={formStatus.pending || !signaturePresent}
                label={messages.save}
                validate={this.formValidate}
                onSubmit={this.doSubmit}
                formStatus={formStatus}
                raiseError={this.raiseError}
              />
            </div>
          </>
        );

        // a photo was taken and user can retake it, make another one or go back to vehicle overvview
      } else if (damagePhotoTaken) {
        renderTitle = (
          <>
            <a
              href="#closeDamagePhotoTaken"
              className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-10 p-b-10 text-master b-rad-lg"
              onClick={this.closeDamagePhotoTaken}
            >
              <i className="fa fa-angle-left m-r-5" /> {messages.back}
            </a>
            {messages.review}
          </>
        );

        renderResult = (
          <Row>
            <Col xs={12} sm={7} className="m-b-10">
              <img src={damagedSidesPhotos[damagedSidesPhotos.length - 1].dataURI} className="img-responsive" alt="" />
            </Col>

            <Col xs={12} sm={5}>
              <Button block className="m-b-10" bsStyle="primary" onClick={this.closeDamagePhotoTaken}>
                <i className="fal fa-plus" /> {messages.another_photo}
              </Button>
              <Button block className="m-b-20" bsStyle="warning" onClick={this.retryLastDamagePhoto}>
                <i className="fal fa-undo" /> {messages.try_again}
              </Button>
              <Button
                block
                onClick={() =>
                  this.setState({
                    damagePhotoTaken: false,
                    makeDamagePhoto: false,
                    damageSide: null,
                  })
                }
              >
                <i className="fal fa-angle-left" /> {messages.back_to_vehicle}
              </Button>
            </Col>
          </Row>
        );

        // on mobile devices, user has the option to make photos
        // in that case, a HTML5 camera will be used
      } else if (makeDamagePhoto) {
        renderTitle = (
          <>
            <a
              href="#closeMakeDamagePhoto"
              className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-10 p-b-10 text-master b-rad-lg"
              onClick={this.closeMakeDamagePhoto}
            >
              <i className="fa fa-angle-left m-r-5" /> {messages.back}
            </a>
            {messages.damages} - {messages.handover_damage[damageSide]}
          </>
        );
        renderResult = (
          <Camera
            idealFacingMode="environment"
            idealResolution={{ width: 2560, height: 1920 }}
            isImageMirror={false}
            onTakePhoto={this.addDamageImage}
          />
        );

        // show the damage notes for a specific side
        // add notes and photos
      } else if (damageSide) {
        renderTitle = (
          <>
            <a
              href="#closeDamageDetails"
              className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-10 p-b-10 text-master b-rad-lg"
              onClick={this.closeDamageDetails}
            >
              <i className="fa fa-angle-left m-r-5" /> {messages.back}
            </a>
            {messages.damages} - {messages.handover_damage[damageSide]}
          </>
        );
        renderResult = (
          <form
            onSubmit={e => {
              e.preventDefault();
              this.setState({ damageSide: null });
              return false;
            }}
          >
            <div className="form-group-attached">
              {!!damagedSides[damageSide] &&
                !!damagedSides[damageSide].length &&
                damagedSides[damageSide].map((damage, i) => {
                  return (
                    <FormTextarea
                      label={messages.damage_note + ' ' + (i !== 0 ? i + 1 : '')}
                      name="damage_note"
                      value={damage.notes}
                      onChange={(name, value) => this.updateDamageNotes(value, i)}
                      key={i}
                    />
                  );
                })}
            </div>

            <MobileView>
              <div className="m-t-10 text-center">
                <Button onClick={this.makeDamagePhoto} bsSize="lg" bsStyle="primary">
                  <i className="fal fa-camera" />
                </Button>
              </div>
            </MobileView>

            {debug && (
              <div className="m-t-10 padding-10 b-a">
                <div>DEBUG ONLY</div>
                <Button onClick={this.makeDamagePhoto} bsSize="lg" bsStyle="primary">
                  <i className="fal fa-camera" />
                </Button>
              </div>
            )}
          </form>
        );

        // display vehicle for the user to choose the side that is damaged
      } else if (this.state.damages) {
        renderTitle = (
          <>
            <a
              href="#closeDamageProtocol"
              className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-10 p-b-10 text-master b-rad-lg"
              onClick={this.closeDamageProtocol}
            >
              <i className="fa fa-angle-left m-r-5" /> {messages.back}
            </a>
            {messages.damages}
          </>
        );
        renderResult = (
          <Clearfix>
            <div className="pull-left relative" style={{ marginLeft: '50%', transform: 'translateX(-50%)' }}>
              <img src={`${projectDomain}/img/handover_car_view.png`} className="img-responsive" alt="" />

              {damagesConfig.map(damageConfig => {
                const damageImgFileName =
                  damageInfos[damageConfig.pos].hasNotes || damageInfos[damageConfig.pos].hasPhotos
                    ? 'danger'
                    : 'complete';

                return (
                  <div
                    style={{
                      position: 'absolute',
                      top: `${damageConfig.top}%`,
                      left: `${damageConfig.left}%`,
                      transform: 'translateX(-50%)',
                    }}
                    className="text-center cursor"
                    onClick={() => this.openDamageDetails(damageConfig.pos)}
                    key={damageConfig.pos}
                  >
                    <Label className="block">{messages.handover_damage[damageConfig.pos]}</Label>
                    <img
                      src={`${projectDomain}/img/maps/pulse-${damageImgFileName}.svg`}
                      width="40"
                      height="40"
                      alt={damageConfig.pos}
                    />
                  </div>
                );
              })}
            </div>
          </Clearfix>
        );

        // display the handover form
      } else if (this.state.handover) {
        modalClass = 'full-width';

        renderTitle = messages.handover;
        renderResult = (
          <div>
            {handoverAttributes.pending ? (
              <Loader />
            ) : (
              <form>
                <Grid fluid className="no-padding">
                  <Row>
                    <Col xs={12} md={7}>
                      <div className="form-group-attached">
                        <FormAutocomplete
                          value={this.state.handoverDifficulties}
                          label={messages.difficulties}
                          options={[
                            { label: '-', value: '' },
                            { label: messages.dark, value: 'dark' },
                            { label: messages.garage, value: 'garage' },
                            { label: messages.snow_ice, value: 'snow_ice' },
                            { label: messages.rain_wet, value: 'rain_wet' },
                          ]}
                          onChange={(name, handoverDifficulties) => this.setState({ handoverDifficulties })}
                        />

                        {carMileage.pending || !mileageLoaded ? (
                          <Row className="clearfix">
                            <Col xs={6}>
                              <div className="form-group form-group-default">
                                <label>{messages.mileage}</label>
                                <div>
                                  <i className="fa fa-fw fa-circle-notch fa-spin m-r-10" />
                                </div>
                              </div>
                            </Col>
                            <Col xs={6}>
                              <div className="form-group form-group-default">
                                <label>{messages.mileage}</label>
                                <div>
                                  <i className="fa fa-fw fa-circle-notch fa-spin m-r-10" />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        ) : (
                          <Row className="clearfix">
                            <Col xs={6}>
                              <FormInput
                                type="number"
                                label={messages.previous_odometer_reading}
                                value={this.state.handoverPreviousMileage}
                                prefixAddon="km"
                                onChange={(name, handoverPreviousMileage) => this.setState({ handoverPreviousMileage })}
                                disabled={formStatus.pending}
                              />
                            </Col>
                            <Col xs={6}>
                              <FormInput
                                type="number"
                                label={messages.current_odometer_reading}
                                value={this.state.handoverMileage}
                                prefixAddon="km"
                                onChange={(name, handoverMileage) => this.setState({ handoverMileage })}
                                disabled={formStatus.pending}
                              />
                            </Col>
                          </Row>
                        )}

                        <Row className="clearfix">
                          <Col xs={9}>
                            <div className="form-group form-group-default">
                              <label>
                                {messages.fuel_level} {this.state.handoverFuelLevel}%
                              </label>
                              <div className="p-b-5 p-t-5">
                                <Slider
                                  step={5}
                                  value={this.state.handoverFuelLevel}
                                  min={0}
                                  max={100}
                                  onChange={handoverFuelLevel => this.setState({ handoverFuelLevel })}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col xs={3}>
                            {carTankVolume.pending || !tankVolumeLoaded ? (
                              <div className="form-group form-group-default">
                                <label>{messages.tank_volume}</label>
                                <div>
                                  <i className="fa fa-fw fa-circle-notch fa-spin m-r-10" />
                                </div>
                              </div>
                            ) : (
                              <FormInput
                                type="number"
                                label={messages.tank_volume}
                                value={this.state.handoverTankVolume}
                                prefixAddon="l"
                                onChange={(name, handoverTankVolume) => this.setState({ handoverTankVolume })}
                                disabled={formStatus.pending}
                              />
                            )}
                          </Col>
                        </Row>

                        <div className="form-group form-group-default">
                          <label>{messages.damages}</label>
                          <div className="clearfix cursor p-t-5 p-b-5" onClick={this.showDamageProtocol}>
                            {damagesConfig.map(damageConfig => {
                              const res = [];
                              if (damageInfos[damageConfig.pos].hasNotes) {
                                res.push(<i className="fal fa-file-alt text-danger m-l-5" key="t" />);
                              }
                              if (damageInfos[damageConfig.pos].hasPhotos) {
                                res.push(<i className="fal fa-images text-danger m-l-5" key="p" />);
                              }

                              return res.length ? (
                                <span className="pull-left m-r-10" key={damageConfig.pos}>
                                  {messages.handover_damage[damageConfig.pos]}
                                  {res}
                                </span>
                              ) : null;
                            })}

                            {/* display information that there are no damages */}
                            {!damageInfos.hasDamages ? (
                              <>
                                <div className="pull-left">{messages.no_damages_in_protocol}</div>
                                <div className="pull-right">
                                  <strong>
                                    {messages.add_damage} <i className="fa fa-angle-right" />
                                  </strong>
                                </div>
                              </>
                            ) : (
                              <div className="pull-right">
                                <a href="#showDamageProtocol" onClick={e => e.preventDefault()}>
                                  <i className="fa fa-angle-right" />
                                </a>
                              </div>
                            )}
                          </div>
                        </div>

                        {handoverAttributes.data.list.map(attr => {
                          return (
                            <div className="form-group form-group-default" key={attr.id}>
                              <FormSwitchery
                                name={attr.id}
                                label={getNameInCurrentLanguage(attr.name, appIntl)}
                                value
                                checked={this.state.selectedHandoverAttributes.indexOf(attr.id) > -1}
                                onChange={(name, checked) => {
                                  this.setState(prevState => ({
                                    selectedHandoverAttributes: checked
                                      ? _concat(prevState.selectedHandoverAttributes, [attr.id])
                                      : _remove(prevState.selectedHandoverAttributes, a => {
                                          return a !== attr.id;
                                        }),
                                  }));
                                }}
                                disabled={formStatus.pending}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </Col>

                    {additionalCostsTotal > 0 ? (
                      <Col xs={12} md={5}>
                        <AdditionalCostsPositions
                          projectConfig={projectConfig}
                          additionalCostsPositions={additionalCostsPositions}
                          additionalCostsTotal={additionalCostsTotal}
                        />

                        <div className="m-t-15">
                          <FormSwitchery
                            label={messages.charge_customer_additional_costs}
                            name="chargeAdditionalCosts"
                            value
                            checked={chargeAdditionalCosts}
                            onChange={(name, chargeAdditionalCosts) => {
                              this.setState({ chargeAdditionalCosts });
                            }}
                            disabled={formStatus.pending}
                          />
                        </div>
                        <div className="m-t-20">
                          {chargeAdditionalCosts ? (
                            <>
                              {isMobile ? (
                                <PaymentOptions
                                  clientId={targetId}
                                  ePaymentTotal={additionalCostsTotal}
                                  currency={webApp.currency}
                                  employee
                                />
                              ) : (
                                <PaymentOptions
                                  clientId={targetId}
                                  ePaymentTotal={additionalCostsTotal}
                                  currency={webApp.currency}
                                />
                              )}
                            </>
                          ) : (
                            <Alert className="m-t-20" bsStyle="danger">
                              {messages.warning_you_chose_not_to_charge_customer_for_additional_costs}
                            </Alert>
                          )}
                        </div>
                      </Col>
                    ) : (
                      <Col xs={12} md={5}>
                        <h4 className="text-success">
                          {messages.no_additional_costs}{' '}
                          <span className="hidden-md hidden-lg">
                            <i className="fal fa-thumbs-up" />
                          </span>
                        </h4>

                        <h1 className="text-success text-center xs-hidden sm-hidden m-t-60">
                          <i className="fal fa-thumbs-up fa-4x" />
                        </h1>
                      </Col>
                    )}

                    <Col xs={12}>
                      <div className="text-right m-t-15">
                        <BrowserView>
                          <CheckoutProceedButton
                            bsStyle={this.getMaySubmit() ? 'primary' : 'default'}
                            bsSize="lg"
                            iconClassName="fal fa-save"
                            disabled={formStatus.pending}
                            label={messages.save}
                            validate={this.formValidate}
                            onSubmit={this.doSubmit}
                            formStatus={formStatus}
                            raiseError={this.raiseError}
                          />
                        </BrowserView>
                        <MobileView>
                          <Button
                            bsSize="lg"
                            disabled={formStatus.pending}
                            bsStyle={this.getMaySubmit() ? 'primary' : 'default'}
                            onClick={this.showSignaturePad}
                          >
                            <i
                              className={
                                'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin ' : 'fal fa-signature ')
                              }
                            />{' '}
                            {messages.client_signature}
                          </Button>
                        </MobileView>

                        {debug && (
                          <div className="m-t-10 padding-10 b-a">
                            <div>DEBUG ONLY</div>
                            <Button
                              bsSize="lg"
                              disabled={formStatus.pending}
                              bsStyle={this.getMaySubmit() ? 'primary' : 'default'}
                              onClick={this.showSignaturePad}
                            >
                              <i
                                className={
                                  'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin ' : 'fal fa-signature ')
                                }
                              />{' '}
                              {messages.client_signature}
                            </Button>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Grid>
              </form>
            )}
          </div>
        );

        // doc photos was just taken
      } else if (makeDocPhoto) {
        renderTitle = (
          <>
            <a
              href="#closeMakeDocPhoto"
              className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-10 p-b-10 text-master b-rad-lg"
              onClick={this.closeMakeDocPhoto}
            >
              <i className="fa fa-angle-left m-r-5" /> {messages.back}
            </a>
            {getNameInCurrentLanguage(docUploadType.name, appIntl)}
          </>
        );

        renderResult = (
          <DocPhoto
            doc={{ type: docUploadType }}
            uploadTarget={docUploadTarget}
            targetId={targetId}
            leadId={lead.id}
            onSuccess={this.docUploaded}
          />
        );

        // if the user wishes to upload documents, give him the chance now
      } else if (docUpload) {
        renderTitle = (
          <>
            <a
              href="#closeDocUpload"
              className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-10 p-b-10 text-master b-rad-lg"
              onClick={this.closeDocUpload}
            >
              <i className="fa fa-angle-left m-r-5" /> {messages.back}
            </a>
            {messages.add_document} - {getNameInCurrentLanguage(docUploadType.name, appIntl)}
          </>
        );

        if (isMobile) {
          // on mobile devices,
          renderResult = (
            <div className="m-t-10 text-center">
              <Button onClick={this.makeDocPhoto} bsSize="lg" bsStyle="primary">
                <i className="fal fa-camera" />
              </Button>
            </div>
          );
        } else {
          renderResult = (
            <>
              <DocUpload
                doc={{ type: docUploadType }}
                uploadTarget={docUploadTarget}
                targetId={targetId}
                leadId={lead.id}
                onSuccess={this.docUploaded}
              />

              {debug && (
                <div className="m-t-10 padding-10 b-a text-center">
                  <div>DEBUG ONLY</div>
                  <Button onClick={this.makeDocPhoto} bsSize="lg" bsStyle="primary">
                    <i className="fal fa-camera" />
                  </Button>
                </div>
              )}
            </>
          );
        }
        // if any data is missing, the user must enter the missing data now
      } else {
        renderTitle = messages.change_stage;
        // display all the stage requirements
        renderResult = (
          <form>
            <div className="panel panel-transparent">
              <div className="form-group-attached">
                {isCarRequired && (
                  <FormAutocomplete
                    label={messages.car}
                    name="item"
                    value={car ? car.id : null}
                    onChange={(name, car) => this.setState({ car })}
                    autocompleteType="car"
                    disabled={formStatus.pending}
                    returnValueObject
                  />
                )}
                {isItemRequired && (
                  <FormAutocomplete
                    label={messages.item}
                    name="item"
                    value={item ? item.id : null}
                    onChange={(name, item) => this.setState({ item })}
                    autocompleteType="item"
                    disabled={formStatus.pending}
                    returnValueObject
                  />
                )}

                {isOrderRequired && (
                  <FormAutocomplete
                    label={messages.order}
                    name="order"
                    value={orderId}
                    onChange={(name, orderId) => this.setState({ orderId })}
                    autocompleteType="order"
                    disabled={formStatus.pending}
                  />
                )}

                {isBudgetRequired && (
                  <FormInput
                    prefixAddon={webApp.currencySymbol}
                    type="number"
                    label={messages.budget}
                    name="budget"
                    value={budget}
                    onChange={(name, budget) => this.setState({ budget })}
                    disabled={formStatus.pending}
                  />
                )}

                {isClientRequired && (
                  <FormAutocomplete
                    label={messages.client}
                    name="target"
                    value={targetId}
                    onChange={this.updateTarget}
                    autocompleteType="client"
                    disabled={formStatus.pending}
                    returnValueObject
                  />
                )}
              </div>

              {!!requireClientDocuments.length && !!targetId && (
                <>
                  <p className="m-t-10">{messages.client_documents}</p>
                  <List
                    noRender
                    listName="clientDocuments"
                    url="/api/documents.json"
                    urlData={{ filters: { target: targetId } }}
                    list={clientDocs}
                  />
                  <div className="form-group-attached">
                    {requireClientDocuments.map((docType, i) => {
                      return this.getClientDocInput(docType, i);
                    })}
                  </div>
                </>
              )}

              {!!requireLeadDocuments.length && (
                <>
                  <p className="m-t-10">{messages.lead_documents}</p>
                  <List
                    noRender
                    listName="leadDocuments"
                    url="/api/documents.json"
                    urlData={{ filters: { lead: lead.id } }}
                    list={leadDocs}
                  />
                  <div className="form-group-attached">
                    {requireLeadDocuments.map((docType, i) => {
                      return this.getLeadDocInput(docType, i);
                    })}
                  </div>
                </>
              )}

              {isHandoverRequired ? (
                <div className="text-right m-t-15">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    bsStyle={this.getMaySubmit() ? 'primary' : 'default'}
                    onClick={() => {
                      if (this.getMaySubmit()) this.setState({ handover: true });
                    }}
                  >
                    <i
                      className={`fa-fw ${formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-chevron-right'}`}
                    />{' '}
                    {messages.handover}
                  </Button>
                </div>
              ) : (
                <div className="text-right m-t-15">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    bsStyle={this.getMaySubmit() ? 'primary' : 'default'}
                    onClick={this.formSubmit}
                  >
                    <i className={`fa-fw ${formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save'}`} />{' '}
                    {messages.save}
                  </Button>
                </div>
              )}
            </div>
          </form>
        );
      }
    }

    return (
      <Modal show={show} onHide={this.close} bsSize="lg" className={modalClass}>
        <Modal.Header closeButton={!countUploading}>
          <Modal.Title>{renderTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormErrors formStatus={formStatus} additionalErrors={errors} />
          {renderResult}

          {(this.state.handover || this.state.damage) && (
            <>
              <List
                noRender
                listName="handoverAttributes"
                url={`/api/handovers/${lead.id}/${car.id}/attributes.json`}
                list={handoverAttributes}
              />
              <Data dataName="carMileage" data={carMileage} url={`/api/items/${car.id}/mileage.json`} />
              <Data dataName="carTankVolume" data={carTankVolume} url={`/api/items/${car.id}/tankvolume.json`} />
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const res = {
    webApp: state.webApp,
    appIntl: state.intl,
    layout: state.layout,
    projectConfig: state.data.projectConfig,
    clientDocs: state.list.clientDocuments,
    leadDocs: state.list.leadDocuments,
    formStatus: state.formStatus.leadChangeStage,
    handoverAttributes: state.list.handoverAttributes,
    carMileage: state.data.carMileage,
    carTankVolume: state.data.carTankVolume,
    user: state.login.user,
    uploadingFiles: [],
    countUploading: 0,
  };

  if (ownProps.lead) {
    res.uploadingFiles = _filter(state.upload.files, { context: 'leadHandover:' + ownProps.lead.id });
    res.countUploading = _filter(res.uploadingFiles, { isUploaded: false, error: 0 }).length;
  }

  return res;
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (leadId, data) => {
      formStatusDispatchHelper('leadChangeStage', `/api/leads/${leadId}/stage.json`, data, 'post', dispatch, 1);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    clientDocumentNewSubmit: (clientId, args) => {
      formStatusDispatchHelper('documentNew', `/api/clients/${clientId}/docs.json`, args, 'post', dispatch);
    },
    leadDocumentNewSubmit: (leadId, args) => {
      formStatusDispatchHelper('leadDocumentNew', `/api/leads/${leadId}/docs.json`, args, 'post', dispatch);
    },
    uploadFile: fileUploadHelper(dispatch),
    updateUploadContext: newContext => {
      dispatch(changeUploadContext(newContext));
    },
    doResetUploadContext: () => {
      dispatch(resetUploadContext());
    },
    doInitCheckout: (items, userData, initData) => {
      dispatch(resetCheckout(initCheckout(items, userData, initData)));
    },
    doUpdateCheckout: params => {
      dispatch(updateCheckout(params));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadChangeStageChecker)
  )
);
